var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"text-center",attrs:{"width":_vm.width,"src":require(("@/assets/images/logo/" + _vm.imageUrl)),"alt":"logo-arch-web"}})])}
var staticRenderFns = []

export { render, staticRenderFns }